import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Seo } from '../components/Seo';

export function ThankYou() {
  const { t } = useTranslation();

  return (
    <>
      <Seo title="Thank You | GYRONAVI" description="Your inquiry has been received by GYRONAVI." path="/thank-you" />
      <section className="section max-w-3xl text-center">
        <p className="eyebrow">{t('common:thankYou.eyebrow')}</p>
        <h1 className="mt-2 text-4xl font-black text-ink">{t('common:thankYou.title')}</h1>
        <p className="mt-4 leading-7 text-slate-600">{t('common:thankYou.text')}</p>
        <Link className="btn-primary mt-8" to="/products">
          {t('common:thankYou.button')}
        </Link>
      </section>
    </>
  );
}
